interface Props extends React.SVGProps<SVGSVGElement> {
   iconId: string;
   className?: string;
   style?: React.CSSProperties;
   onClick?: () => void;
}

export const SvgIcon = ({
   iconId,
   className,
   style,
   onClick,
   ...rest
}: Props) => {
   return (
      <svg className={className} style={style} onClick={onClick} {...rest}>
         <use
            href={`${process.env.PUBLIC_URL}/assets/svg/material-symbols-icons.svg#${iconId}`}
         />
      </svg>
   );
};
